/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.3.0
 */

import { ICockpitTranslation } from '../types/cockpit';

const initCockpitTranslation: ICockpitTranslation = {
    error: {
        codes: {},
        defaultMessage: '',
    },
    login: {
        title: '',
        subTitle: '',
        btnLogin: '',
        password: {
            label: '',
            placeholder: '',
        },
    },
    menu: {},
};

export default initCockpitTranslation;
